import { Component, OnInit, inject } from "@angular/core";
import { ModalController, IonicModule } from "@ionic/angular";
import { Gender, Person } from "../services/spiritual-gifts/spiritual-gifts.service";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TakeTestComponent } from "../take-test/take-test.component";
import { GroupsService } from "../services/rock/Groups/Groups.service";
import { PeopleService } from "../services/rock/People/People.service";
import { addIcons } from 'ionicons';
import { reloadOutline, sync } from 'ionicons/icons';

import ConnectionGroups from './ConnectionGroups.json';
import { FirebaseService } from "../services/firebase/firebase.service";

const parentConnectionGroup = 4322;
const studentMinistries = 4414;

@Component({
		selector: 'app-gifts-assessment',
		templateUrl: './gifts-assessment.component.html',
		styleUrl: './gifts-assessment.component.scss',
		standalone: true,
		imports: [IonicModule, FormsModule, ReactiveFormsModule]
})
export class GiftsAssessmentComponent implements OnInit {

		private modalCtrl = inject(ModalController);
		private groupsService = inject(GroupsService);
		private peopleService = inject(PeopleService);
		private firebaseService = inject(FirebaseService);

		lInstructions: string = `<p>Here you'll find a series of statements designed to help you
			discover how God has uniquely gifted you for His work. Please respond to each one using
			the scale from 'Disagree' to 'Strongly Agree.' Be sure to answer every question.
			<strong>Your results will be scored once you've completed the test.</strong></p>`;
		
		private fb = inject(FormBuilder);
		form: FormGroup;

		connectionGroups = ConnectionGroups;

		testTypeOptions = {
			type: 'lbc_2022',
			randomizeQuestions: false,
			allowAutomate: false
		}
		showTestTypeOptions: boolean = false;

		targetPerson: Person = new Person();

		constructor() {
			addIcons({ reloadOutline, sync });
		}

		async ngOnInit(): Promise<void> {
			this.form = this.fb.group({FirstName: {}, LastName: {}, Number: {}, Email: {}, Gender: {}, ConnectionGroup: {}});
			this.clearData();
			this.connectionGroups = await this.getGroups();

			// this.testPerson();
		}

		testPerson() {
			const person = new Person();
			person.Gender = Gender.Male;
			person.FirstName = 'test';
			person.LastName = 'test';
			person.Email = 'test@test.com';
			person.PhoneNumbers[0].Number = '6619464663';

			const connectionGroup = this.connectionGroups[0].Groups.find(g => g.Name === 'His Design');
			person.ConnectionGroup = connectionGroup.Id;

			this.targetPerson = person;
			this.testTypeOptions.allowAutomate = true;
		}

		clearData() {
			this.targetPerson = new Person();
		}

		async getGroups(findRockGroups: boolean = false) {

			if (!findRockGroups) {
				return ConnectionGroups;
			}

			let allGroups = [
				{
					Id: 'adults',
					Name: 'Connection Groups',
					Groups: []
				}, {
					Id: 'students',
					Name: 'Student Ministries',
					Groups: []
				}
			];
	
			// Recursive function to drill down
			const drill = async (groupId, i) => {
				let groups = [];

				try {
					groups = await this.groupsService.GetGroupsGetChildrenByid(groupId);
				} catch (error) {
					console.error(`Failed to fetch groups for groupId ${groupId}:`, error);
				}
		
				for (const group of groups) {
					if (group.HasChildren) {
						await drill(group.Id, i);
					} else {
						if (group.IsActive) {
							allGroups[i].Groups.push(group);
						}
					}
				}
			};
		
			await drill(parentConnectionGroup, 0);
			await drill(studentMinistries, 1);
			
			const getSortKey = s => s.replace(/^(\d+)/, n => n.padStart(2, '0'));
			for (const g of allGroups) {
				g.Groups.sort((a, b) => getSortKey(a.Name).localeCompare(getSortKey(b.Name)));
			}

			// allGroups.map(async (group) => {
			// 	const g = await this.groupsService.GetGroupsByid(group.Id);
			// 	console.log(g);
			// });

			if (!allGroups.length) {
				allGroups = ConnectionGroups;
			}
		
			return allGroups;
		}
		
		async startTest(findRockPerson: boolean = false) {

			if (findRockPerson) {
				let realPerson = this.targetPerson;
				const rockPeople = await this.peopleService.GetPeopleGetByEmailByemail(this.targetPerson.Email);
				if (rockPeople?.length === 1) {
					realPerson = rockPeople[0];
				}
				if (rockPeople?.length && rockPeople.length > 1) {
					const filter = `$filter=FirstName%20eq%20'${this.targetPerson.FirstName}'%20and%20LastName%20eq%20'${this.targetPerson.LastName}'%20and%20Email%20eq%20'${this.targetPerson.Email}'`;
					const rockPerson = await this.peopleService.GetPeople(filter);
					if (rockPerson?.length === 1) {
						realPerson = rockPerson[0];
					}
				}
			}

			this.targetPerson.PhoneNumbers[0].FullNumber = `${this.targetPerson.PhoneNumbers[0].CountryCode}${this.targetPerson.PhoneNumbers[0].Number}`;

			const modal = await this.modalCtrl.create({
				component: TakeTestComponent,
				id: 'takeTest',
				cssClass: 'fullscreen',
				componentProps: {
					_targetPerson: this.targetPerson,
					testTypeOptions: this.testTypeOptions,
				}
			});
	
			modal.present();

			const { data, role } = await modal.onWillDismiss();

			if (role === 'submit') {
				this.clearData();
				console.log(data);
			}
		}

}